import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OrderTypeConfig } from 'ngx-web-api';

@Component({
  selector: 'fts-order-type-selector',
  templateUrl: 'order-type-selector.component.html',
  styleUrls: ['order-type-selector.component.scss'],
})
export class OrderTypeSelectorComponent {
  @Input()
  orderTypeConfigs: OrderTypeConfig[];
  @Input()
  selectedOrderTypeConfig: OrderTypeConfig;
  @Input()
  radioStyle: boolean;
  @Input()
  disabled: boolean;
  @Input()
  orderAheadConfig: OrderTypeConfig;
  @Input()
  isOrderAheadSelected = false;

  @Output()
  orderTypeConfigChange = new EventEmitter<OrderTypeConfig>();
  @Output()
  orderAheadChange = new EventEmitter<boolean>();

  readonly ORDER_AHEAD_VALUE = '__ORDER_AHEAD__';

  get selectedRadioValue(): string {
    if (this.isOrderAheadSelected) {
      return this.ORDER_AHEAD_VALUE;
    }
    return this.selectedOrderTypeConfig?.type;
  }

  onOrderTypeConfigChange(orderTypeConfig: OrderTypeConfig | string) {
    if (orderTypeConfig === this.ORDER_AHEAD_VALUE) {
      this.orderTypeConfigChange.emit(this.orderAheadConfig);
      this.orderAheadChange.emit(true);
    } else {
      this.orderTypeConfigChange.emit((orderTypeConfig as unknown) as OrderTypeConfig);
      this.orderAheadChange.emit(false);
    }
  }

  onRadioChange(value: string) {
    if (value === this.ORDER_AHEAD_VALUE) {
      this.orderTypeConfigChange.emit(this.orderAheadConfig);
      this.orderAheadChange.emit(true);
    } else {
      const config = this.orderTypeConfigs.find(c => c.type === value);
      if (config) {
        this.orderTypeConfigChange.emit(config);
        this.orderAheadChange.emit(false);
      }
    }
  }
}
